export default {
    apolloUri: process.env.REACT_APP_APOLLO_URI,
    hostname: process.env.REACT_APP_HOST,
    baseName: process.env.REACT_APP_BASENAME,
    easy360BaseUrl: process.env.REACT_APP_EASY_360_BASE_URL,
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL
}